import React, { MouseEvent } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import Typography from "../../typography/Typography/Typography";
import { StyledVrmBox, StyledVrmLeftBorder } from "./Vrm.styles";
import { TypographyVariantOptions } from "../../typography/Typography/Typography.types";
import { VrmProps } from "./Vrm.types";

const Vrm: React.FC<VrmProps> = ({
	size = "md",
	text,
	variant = "default",
	className,
}) => {
	const block = new BemIt("Vrm");

	const getTypographySize = (): TypographyVariantOptions => {
		switch (size) {
			case "sm":
				return "body-small";
			case "lg":
				return "body-large";
			default:
				return "body";
		}
	};

	return (
		<StyledVrmBox className={addClass(className).after(block)} size={size}>
			<StyledVrmLeftBorder size={size} variant={variant} />
			<Typography
				className={block.el("text").out}
				htmlTag="span"
				variant={getTypographySize()}
				color="fg_dark_3"
				weight="heaviest"
			>
				{text}
			</Typography>
		</StyledVrmBox>
	);
};

export default Vrm;
